import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
    getIncompleteRegistration,
} from "../../../actions/emActions";
import RightSectionEM from "../RightSectionEM/RightSectionEM";
import HeaderComponent from "../../website/HeaderComponent";

const IncompleteRegistration = (props) => {
    const [incomplete, setincomplete] = useState('');
    useEffect(() => {
        props.getIncompleteRegistration()
            .then((res) => {
                setincomplete(res.data);
                console.log(res);
            })
            .catch((err) => {
                console.log(err);
                debugger;
            })
    }, [])
    return (
        <div className="FeedComponent FeedComponentForTeacher">
            <HeaderComponent
            // whiteLabel={this.state.isWhiteLabel}
            // headerData={{ studentName: this.state.teacherInfo.user_name }}
            />
            <div style={{ padding: "2vh 0" }}>
                <div className="container-fluid">
                    <div className="row">

                        <div className="col-md-3">
                            <RightSectionEM />
                        </div>

                        <div className="col-md-9">

                            <h5>Incomplete Registration</h5>

                            <hr />

                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">User Name</th>
                                        <th scope="col">Course Name</th>
                                        <th scope="col">Contact</th>
                                        <th scope="col">Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {incomplete.data && incomplete.data.map((item, index) =>
                                        <tr>
                                            <th scope="row">{index + 1}</th>
                                            <td>{item.username}</td>
                                            <td>{item.course_name}</td>
                                            <td>{item.contact}</td>
                                            <td>{item.created_at}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(null, {
    getIncompleteRegistration,
})(IncompleteRegistration);